
angular.module('acme.view.application.orders.offline.order.detail.controllers', [
    'ui.router',
    'ui.bootstrap',
    'acme.common.directive.dataGrid',
    'acme.common.service.offline'
]).controller('OfflineOrderDetailController', OfflineOrderDetailController);

/**
 * Controller responsible for managing the offline execution history list view
 * @class OfflineOrderDetailController
 * @constructor
 * @param {Object} $q - angular's $q service
 * @param {Object} $uibModalInstance - angular's $uibModalInstance service
 * @param {Object} OfflineService - acme's OfflineService
 * @param {Object} HelpersService - acme's HelpersService
 * @param {Number} posUUID - posUUID that will be used to fetch the transactions history
 * @return {OfflineOrderDetailController} - Class instance
 */
function OfflineOrderDetailController($q, $uibModal, $uibModalInstance, OfflineService, HelpersService, posUUID, orderNumber, orderId) {
    Object.assign(this, {
        $q: $q,
        $uibModal: $uibModal,
        $uibModalInstance: $uibModalInstance,
        OfflineService: OfflineService,
        HelpersService: HelpersService,
        posUUID: posUUID
    });
    this.vm = {};
    this.paymentDetails = {
        columns: 1,
        data: '$ctrl.vm.details',
        include: [
            'paymentMethods',
            'ccLastFourDigits',
            'checkNumber',
            'voucherNumber'
        ],
        mappings: {
            paymentMethods: 'Payment Method',
            ccLastFourDigits: 'Card Last 4 Digits',
            checkNumber: 'Check Number',
            voucherNumber: 'Voucher Number'
        }
    };
    this.billingDetails = {
        columns: 1,
        data: '$ctrl.vm.details',
        include: [
            'contactFirstName',
            'contactLastName',
            'email',
            'phone'
        ],
        mappings: {
            contactFirstName: 'First name',
            contactLastName: 'Last name',
            email: 'Email',
            phone: 'Phone number'
        }
    };

    this.goToTransactionDetail = function() {
        this.$uibModalInstance.close();
        this.$uibModal.open({
            templateUrl:
                'views/application/views/orders/offline/list/detail.tpl.html',
            size: 'lg',
            controller: 'OfflineDetailController',
            controllerAs: '$ctrl',
            resolve: {
                posUUID: function() {
                    return posUUID;
                },
                orderNumber: function() {
                    return orderNumber;
                },
                orderId: function() {
                    return orderId;
                }

            }
        });
    };
    // TODO: update ui-router to 0.3.0 to avoid calling this manually
    // this.$onInit();
}

/**
 * Angular lifecycle method $onInit
 * @public
 * @memberOf OfflineDetailController
 * @return {Undefined} -
 */
OfflineOrderDetailController.prototype.$onInit = function () {
    this.loading = false;
    this.vm = this._getVm();
    this._load(this.posUUID);
};

/**
 * Loads the history and the detail for a particular posUUID
 * Updates the UI
 * @private
 * @memberOf OfflineDetailController
 * @param {Number=} posUUID - transaction posUUID
 * @return {Promise} -
 */
OfflineOrderDetailController.prototype._load = function (posUUID) {
    var getVm = this._getVm.bind(this),
        updateView = this._updateView.bind(this),
        processData = this._processData.bind(this),
        request = this._getDetails(posUUID);

    this.loading = true;
    return request
        .then(processData)
        .then(getVm)
        .then(updateView);
};

/**
 * Request the server for the executions history
 * @memberOf OfflineDetailController
 * @param {Object} line - row data
 * @private
 * @return {{transaction: Object, history: Array}} - aggregate data
 */
OfflineOrderDetailController.prototype._processData = function (responses) {
    var _responses = responses || [];

    return {
        details: _responses[0],
        orderItems: _responses[0].orderItems || []
    };
};

/**
 * Request the server for the executions history
 * @memberOf OfflineDetailController
 * @param {Number=} posUUID - transaction posUUID
 * @private
 * @return {Promise} -
 */
OfflineOrderDetailController.prototype._getDetails = function(posUUID) {
    var request = this.$q.resolve();

    if (posUUID) {
        request = this.$q.all([
            this.OfflineService.details(posUUID)
        ]);
    }

    return request;
};

function extractEvents(events, item) {
    if (!events[item.eventId]) {
        events[item.eventId] = {
            id: item.eventId,
            name: item.eventName,
            startDate: item.eventStartTime ? new Date(item.eventStartTime) : null,
            tickets: []
        };
    }
    return events;
}
/**
 * Process the ViewModel based on the passed data
 * @memberOf OfflineDetailController
 * @param {{transaction: Object, history: Array}} - data used to compute the viewModel
 * @private
 * @return {Object} - the viewModel
 */
OfflineOrderDetailController.prototype._getVm = function (data) {
    var _data = data || {},
        _details = _data.details || {},
        orderItems = _data.orderItems || [],
        events = orderItems.reduce(extractEvents, {}),
        totalTickets = 0,
        totalItems = 0,
        totalMemberships = 0,
        details = Object.assign({
            paymentMethods: '-',
            contactFirstName: '-',
            contactLastName: '-',
            email: '-',
            phone: '-'
        }, _details);

    if (/check/i.test(_details.paymentMethods)) {
        details.checkNumber = _details.paymentId;
    }

    if (/voucher/i.test(_details.paymentMethods)) {
        details.voucherNumber = _details.paymentId;
    }

    if (!!_details.ccLastFourDigits) {
        details.ccLastFourDigits = _details.ccLastFourDigits;
    }

    orderItems.map(function(item) {
        var event = events[item.eventId];
        if (event) {
            event.tickets.push({
                // event names are as displayName
                // membership name is item.eventName for now
                name: item.displayName || item.eventName,
                type: item.itemType,
                quantity: item.quantity,
                price: item.unitPrice,
                discountPrice: '-',
                subtotal: item.amount,
                discountSubtotal: '-'
            });

            switch (item.itemType) {
                case "MembershipPurchase":  totalMemberships += item.quantity;
                                            event.label = "Membership:";
                                            event.type = "membership";
                                            break;

                case "Inventory":           totalItems += item.quantity;
                                            event.label = "Item:";
                                            event.type = "inventory";
                                            break;

                default:                    totalTickets += item.quantity;
                                            event.label = "Event:";
                                            event.type = "event";
            }
        }
    });

    return {
        details: details,
        events: Object.values(events),
        totalTickets: totalTickets,
        totalItems: totalItems,
        totalMembership: totalMemberships
    };
};

/**
 * Request the server for the executions history
 * @memberOf OfflineDetailController
 * @param {Number=} posUUID - transaction posUUID
 * @private
 * @return {Promise} -
 */
OfflineOrderDetailController.prototype._detail = function (posUUID) {
    var request = this.$q.resolve();

    if (posUUID) {
        request = this.OfflineService.executions(posUUID);
    }

    return request;
};


/**
 * Updates the viewModel
 * @memberOf OfflineDetailController
 * @param {Object} vm - Object containing the data to update the public vm property
 * @private
 * @return {Undefined} -
 */
OfflineOrderDetailController.prototype._updateView = function (vm) {
    this.vm = Object.assign({}, this.vm, vm);
    this.loading = false;
};

OfflineOrderDetailController.$inject = [
    '$q',
    '$uibModal',
    '$uibModalInstance',
    'OfflineService',
    'HelpersService',
    'posUUID'
];
